module.exports = __webpack_public_path__ + "static/img/img7.37327c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/img7.png
// module id = VSwR
// module chunks = 1